/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ChatShowMessagePathParams, ChatShowMessageResponse } from '../types/ChatShowMessage'

/**
 * GET /chat/:chat/messages/:providerMessageId
 * @see backend/nexus/modules/AdGeneration/Http/Controllers/ChatController.php ChatController::showMessage
 */
export async function chatShowMessage(
	chat: ChatShowMessagePathParams['chat'],
	providerMessageId: ChatShowMessagePathParams['providerMessageId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ChatShowMessageResponse>> {
	return axiosInstance.get(`/chat/${chat}/messages/${providerMessageId}`, config)
}
